<template>
  <section class="flex flex-col items-center text-center my-5">
    <div class="h-40 w-54">
      <lottie-animation
        :animation-data="loader"
        :auto-play="true"
        :loop="true"
        :speed="1.5"
        ref="animation"
      />
    </div>
    <h2 class="font-bold text-base text-black-10 mt-4">Awaiting Approval</h2>
    <p class="text-sm text-gray-muted font-normal w-2/3 my-4">
      This transaction requires your authorization to proceed. Kindly review the
      details and provide your approval.
    </p>

    <el-tooltip
      content="You do not have the access to approve this transaction"
      placement="top"
      :disabled="hasApproverAccess"
    >
      <button
        @click="openAuthDialog"
        class="approveButton"
        :disabled="!hasApproverAccess"
      >
        Approve Swap
      </button>
    </el-tooltip>

    <!-- Dialogs -->
    <verify-auth-dialog
      v-if="showVerifyAuthDialog"
      :authState="authAction"
      :showDialog="showVerifyAuthDialog"
      @closeDialog="closeAuthDialog"
      @processSwapApproval="processSwapApproval"
    />
  </section>
</template>

<script>
import userKinds from '@/mixins/userKinds.js'
import LottieAnimation from 'lottie-web-vue'
import SwapLoader from '@/assets/lotties/swapLoader.json'

export default {
  name: 'AwaitingApprovalScreen',
  mixins: [userKinds],
  components: {
    LottieAnimation,
    VerifyAuthDialog: () => import('@/components/v2/auth/VerifyAuthDialog.vue')
  },
  data () {
    return {
      showVerifyAuthDialog: false,
      authAction: '',
      animation: '',
      Loader: SwapLoader
    }
  },
  computed: {
    loader () {
      return this.Loader
    },
    initiatedSwapDetails () {
      return this.$store.state.bridge.initiatedSwapDetails.swap
    }
  },
  methods: {
    nextStep () {
      this.$emit('next')
    },
    openAuthDialog () {
      this.authAction = 'processSwapApproval'
      this.showVerifyAuthDialog = true
    },
    closeAuthDialog () {
      this.showVerifyAuthDialog = false
    },
    async processSwapApproval (twoFaCode) {
      const payload = {
        referenceID: this.initiatedSwapDetails.id,
        transactionType: 'swap',
        twoFaCode: twoFaCode,
        action: 'approve'
      }

      await this.$store
        .dispatch('bridge/processSwapApproval', payload)
        .then(() => {
          this.showVerifyAuthDialog = false
          this.$notify({
            title: 'Approved',
            message: 'Transaction approved successfully.',
            type: 'success'
          })

          this.nextStep()
        })
        .catch((error) => {
          this.showVerifyAuthDialog = false
          this.handleErrorResponseNotification(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.approveButton {
  background-color: var(--color-primary);
  color: #ffffff;
  font-size: 14px;
  padding: 18px 90px;
  border-radius: 8px;
  margin-bottom: 30px;

  &:hover {
    opacity: 0.8;
  }

  &:active {
    transform: translateY(1px);
  }

  &:disabled {
    transform: translateY(0);
    background-color: #cacaca;
  }
}
</style>
